<template>
  <a-select
    show-search
    :placeholder="'请选择'"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="null"
    :multiple="multiple"
    @search="(value) => handleSearch(value)"
    @change="(value) => handleChange(value)"
  >
    <a-select-option
      v-for="(item, index) in dictOptions"
      :key="index"
      :value="item[fieldCode]"
    >
      <span style="display: inline-block; width: 100%" :title="item[fieldCode]">
        {{ item[fieldCode] }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
/**
 * author 周娇
 * desc 下拉选择框-带搜索
 * params:
 *  requestUrl  下拉数据请求的接口地址
 *  size : 尺寸
 * multiple 是否支持多选
 *
 */
import { getAction } from '@/api/manage';
export default {
  name: 'SelectSearch',
  props: {
    requestUrl: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'default',
    },
    fieldCode: {
      type: Array,
      default: ['name'],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dictOptions: [], //用于页面显示
      originOptions: [], //原始数组
      selectedOption: '', //选中的数据
      timer: '',
    };
  },
  created() {
    this.initOptions();
  },
  watch: {
    initOptions(val) {
      this.initOptions();
    },
  },
  methods: {
    initOptions() {
      if (this.requestUrl == '') {
        return;
      }
      let params = {};
      getAction(this.requestUrl, params).then((res) => {
        if (res.success && res.result) {
          this.originOptions = res.result;
        } else {
          this.originOptions = [];
          this.$message.error(res.message);
        }
      });
    },
    handleSearch(val) {
      let arr = [];
      let code = this.fieldCode;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.originOptions.forEach((item) => {
          if (code.length > 1) {
            if (
              item[code[0]].indexOf(val) > -1 ||
              item[code[1]].indexOf(val) > -1
            ) {
              arr.push(item);
            }
          } else {
            if (item[code[0]].indexOf(val) > -1) {
              arr.push(item);
            }
          }
        });
        this.dictOptions = arr;
      }, 300);
    },
    handleChange(val) {
      this.selectedOption = val;
      this.$emit('handleVal', val);
      this.initOptions();
    },
  },
};
</script>
